import React from "react";
import GlobalConstants from "../../../config/GlobalConstants";
import Strings from "../../../config/Strings";
import {TigerSpinnerWhite} from "../../../global/tiger-spinner/TigerSpinner";
import logo from "../../../../assets/images/loader_bg.png";
import add from "../../../../assets/images/add.png";
import {SingleCardItem} from "./single-item/SingleCardItem";
import {CreateProfile} from "../../profiles/ProfileService";
import './DashboardCard.scss';
import {useToasts} from "react-toast-notifications";

export const ProfilesCard = (props) => {
    const {profiles, maxProfiles, loading, history} = props;
    const toastFuncs = useToasts();

    if (loading) {
        return (
            <div className={"flex-spinner"}>
                <TigerSpinnerWhite/>
            </div>
        )
    }

    const getCover = (profile) => {
        if (profile != null && profile._links != null && profile._links.avatar != null && profile._links.avatar.href != null) {
            return profile._links.avatar.href;
        } else {
            return logo;
        }
    }

    const openProfile = (profile) => {
        history.push({
            pathname: "/" + GlobalConstants.APP_PATH + "profile-details",
            state: profile._links.self.href.replace("{?projection}", "")
        });
    }

    const createNewProfile = async () => {
        const newProfile = {name: "Neues Profil", defaultProfile: false};
        let response = await CreateProfile(newProfile);
        if (!response.error) {
            history.push({
                pathname: "/" + GlobalConstants.APP_PATH + "profile-details",
                state: response.result._links.self.href
            });
        } else {
            if (response.result && response.result.message && response.result.message.includes("reached max number of profiles")) {
                toastFuncs.addToast(Strings.PROFILES_MAX_NUMBER_ERROR, {autoDismiss: true, appearance: "error"});
            } else {
                toastFuncs.addToast(Strings.PROFILES_UNKNOWN_ERROR + response.message, {autoDismiss: true, appearance: "error"});
            }
        }
    }

    return (
        <>
            <h4 className="dashboard-card-header">{Strings.DASHBOARD_PROFILES_CARD_LABEL}</h4>
            <div className="dashboard-card-content" style={{color: "#fefefe", paddingLeft: '15px', paddingRight: '15px'}}>
                {profiles
                    .map(profile => (
                    <SingleCardItem icon={getCover(profile)}
                                    label={profile.name}
                                    key={profile.id}
                                    enabled={profile.enabled}
                                    sublabel={null}
                                    onClick={() => openProfile(profile)}
                                    rounded
                                    centered
                    />
                ))}

                {profiles.length < maxProfiles &&
                    <SingleCardItem icon={add}
                                    label={<>{Strings.PROFILES_NEW}</>}
                                    sublabel={null}
                                    onClick={() => createNewProfile()}
                                    rounded
                                    centered
                    />
                }
                <br/>
            </div>
        </>
    );
};